var _g, _rect, _circle, _rect2, _rect3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 358,
    viewBox: "0 0 454 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_411_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 1H420C437.121 1 451 14.8792 451 32V322C451 339.121 437.121 353 420 353H34C16.8792 353 3 339.121 3 322V32C3 14.8792 16.8792 1 34 1Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 59H451V321C451 338.121 437.121 352 420 352H34C16.8792 352 3 338.121 3 321V59Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 9,
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 29,
    r: 9,
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 29,
    r: 9,
    fill: "#FFBD44"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 205,
    width: 228,
    height: 19,
    rx: 6,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 141,
    r: 36,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 241,
    width: 288,
    height: 19,
    rx: 6,
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 276,
    width: 258,
    height: 19,
    rx: 6,
    fill: "#EBEBEB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.099 140.036C232.355 140.036 236.616 135.774 236.616 130.518C236.616 125.261 232.355 121 227.099 121C221.842 121 217.581 125.261 217.581 130.518C217.581 135.774 221.842 140.036 227.099 140.036Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.197 159.071C243.968 155.238 241.552 151.893 238.3 149.52C235.047 147.148 231.125 145.869 227.099 145.869C223.072 145.869 219.15 147.148 215.897 149.52C212.645 151.893 210.229 155.238 209 159.071H245.197Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_411_137",
    x: 0,
    y: 0,
    width: 454,
    height: 358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_411_137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_411_137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(206 121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.d91e2bcab3774dbbb42281d8f3ba7f08.svg";
export { ForwardRef as ReactComponent };